import { getCookies, removeCookies } from '../hooks/useCookies';

const AUTH_COOKIE_KEYS = [
  'Token',
  'refreshToken',
  'USERID',
  'USERNAME',
  'USERROLE',
  'USERPERMISSION',
  'USERMENU',
  'PROFILE',
  'THEME',
  'SITE_SETTINGS',
];

export const clearAuthCookies = () => {
  AUTH_COOKIE_KEYS.forEach((key) => removeCookies(key));
};

/**
 * Decodes the stored JWT and checks whether it has not yet expired.
 * Returns false when the cookie is missing, malformed, or past its `exp` claim.
 */
export const isTokenValid = () => {
  const token = getCookies('Token');
  if (!token) return false;
  try {
    const base64Payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const { exp } = JSON.parse(atob(base64Payload));
    return typeof exp === 'number' && exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

/**
 * Hard-clears every auth cookie, marks the session as expired, and
 * performs a full-page redirect to /login.
 * Use this whenever a refresh attempt fails or the session is definitively invalid.
 */
export const forceLogout = () => {
  clearAuthCookies();
  sessionStorage.setItem('cookiesCleared', true);
  window.location.href = '/login';
};
